function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "\u8FD4\u56DE CocoRobo \u7DB2\u7AD9");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Nav__Logo",
  transform: "translate(22.000000, 44.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M248.674703,40.2587314 C248.359129,39.3494727 248.014866,38.4616925 247.641915,37.5739124 C246.465683,34.4308842 245.160353,31.4024083 243.761786,28.4598466 C243.711581,28.3954109 243.682892,28.3309752 243.618343,28.3166562 C225.19311,-2.45495013 163.821091,-9.35672503 100.613004,13.5966882 C36.9961051,36.7219298 -5.73551673,81.8913259 0.62617319,117.309459 C1.30035453,120.080192 2.11080658,122.829447 3.09339003,125.521426 C3.40179213,126.688427 3.81777636,127.855428 4.24093274,129.086865 C29.6876924,196.157226 104.772847,229.942989 171.947128,204.55534 C237.938006,179.61874 271.962648,106.742011 248.674703,40.2873695 L248.674703,40.2587314 Z M190.831378,124.855591 L181.364151,119.758014 C169.946101,126.402046 157.961451,131.98647 145.546474,136.468328 C84.2461763,158.755906 25.3628908,151.238413 13.8300865,119.643462 C2.32597084,88.0413514 42.597548,44.554442 103.91219,22.2740234 C165.219659,0.0294024525 224.059912,7.56121489 235.542511,39.0845706 C242.33453,57.7422732 231.117299,80.6312508 208.030174,100.82825 L208.030174,134.098528 L190.831378,124.855591 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M181.171866,93.8424175 L181.171866,93.7128315 L181.401496,93.7128315 C201.228634,78.5512773 211.676811,61.3451449 206.818696,47.9042039 C198.982563,26.3353451 155.116006,22.7357358 108.852684,39.6251025 C62.5750092,56.50727 31.3955246,87.6078942 39.1957777,109.104761 C47.0247346,130.608827 90.8554116,134.273229 137.111558,117.441456 C145.679638,114.331393 154.010911,110.602198 162.069498,106.25387 L181.05705,120.155561 L181.236449,120.155561 L181.236449,93.8424175 L181.171866,93.8424175 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Footer__Logo.a5cb6124.svg";
export { SvgComponent as ReactComponent };